import LastRead from './LastRead';
import '../styles/HeaderHome.css';
import { UserAuth } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useEffect, useState } from 'react';

const HeaderHome = () => {
  const { user } = UserAuth();
  const [userName, setUserName] = useState('');

  const getUserName = async () => {
    try {
      if (user?.uid) {
        const userRef = doc(db, user.uid, 'Data Pengguna');
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          const namaPengguna = docSnap.data();
          return namaPengguna;
        } else {
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchUserName = async () => {
    const namaPengguna = await getUserName();
    setUserName(namaPengguna);
  };

  useEffect(() => {
    fetchUserName();
  }, [user, setUserName]);
  return (
    <div className='header-home-wrapper'>
      <div className='header-home'>
        <LastRead />
        <div className='hello-user'>
          <p className='hello'>Assalamualaikum</p>
          <p className='user'>{userName && userName.user_name}</p>
        </div>
      </div>
    </div>
  );
};

export default HeaderHome;
